import { Icon, Header, Button, Modal } from 'semantic-ui-react';
import swal from 'sweetalert';
import htmlToDraft from 'html-to-draftjs';
import MicRecorder from 'mic-recorder-to-mp3';
import { ButtonArquivo } from '../../../../components/DuvidasStyles';
import { stateToHTML } from 'draft-js-export-html';
import React, { Component } from 'react';
import { producaov2 as api } from '../../../../services/apis';

// ----newDraft------
import { EditorState, AtomicBlockUtils, ContentState, convertFromHTML } from 'draft-js';
import Editor from '@draft-js-plugins/editor';
import createImagePlugin from '@draft-js-plugins/image';
import createToolbarPlugin, { Separator } from '@draft-js-plugins/static-toolbar';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from '@draft-js-plugins/buttons';
import '../editorStyles.css';
import {
  ContainerInput,
} from './styled'
import "../../../../../node_modules/@draft-js-plugins/static-toolbar/lib/plugin.css";

//------------------

const toolbarPlugin = createToolbarPlugin();
const { Toolbar } = toolbarPlugin;
const imagePlugin = createImagePlugin();
const plugins = [toolbarPlugin, imagePlugin];

let blob = [];
let constraintObj = {
  audio: true,
  video: {
    facingMode: "user",
    width: { min: 640, ideal: 1280, max: 1920 },
    height: { min: 480, ideal: 720, max: 1080 }
  }
};

class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener('click', this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((Button, i) => (
          // eslint-disable-next-line
          <Button key={i} {...this.props} />
        ))}
      </div>
    );
  }
}
class HeadlinesButton extends Component {
  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className='headlineButtonWrapper'>
        <button onClick={this.onClick} className='headlineButton'>
          H
        </button>
      </div>
    );
  }
}



const Mp3Recorder = new MicRecorder({ bitRate: 128 });

export default class SimpleImageEditor extends Component {
  // this.onChange = editorState => this.setState({ editorState })
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createWithContent(ContentState.createFromBlockArray(
        convertFromHTML(this.props.value).contentBlocks,
        convertFromHTML(this.props.value).entityMap,
      )),
      openVideoRec: false,
      isRecording: false,
      anexarVideo: false,
      recordingVideo: false,
      blobURL: '',
      blobArchieve: '',
      imageCount: 0,
      openRec: false,
    };
  }
  ;

  onClick = () => this.props.onOverrideContent(HeadlinesPicker);

  uploadAnexo = async (e, fileType) => {
    const handleFileType = (fileType) => {
      if (fileType === 'vídeo') {
        return new File([blob], 'teste.mp4', { type: 'video/mp4', lastModified: Date.now() });
      }

      if (fileType === 'áudio') {
        return new File([this.state.blobArchieve], 'teste.mp3', { type: 'audio/mp3', lastModified: Date.now() });
      }

      return null;
    }

    const handleFilePath = (fileType) => {
      if (fileType === 'vídeo' || fileType === 'áudio') {
        return 'imagens-voitto/audios_voitto_connect';
      }

      return 'ppas';
    }


    const data = new FormData();
    const file = fileType === 'arquivo' ? e.target.files[0] : handleFileType(fileType);

    data.append("file", file);
    data.append("nome", `${Date.now()}`)
    data.append("path", handleFilePath(fileType));

    try {
      swal("Arquivo anexado!", "Seu arquivo foi anexado com êxito", "success");
      const urlPath = await api.post("/upload", data);
      const base = urlPath.data.url.replace('%2F', '/');



      const html_current = stateToHTML(this.state.editorState.getCurrentContent()) + `
               <p><a href="${base}">Anexo de ${fileType}</a></p>`;
      const { contentBlocks, entityMap } = htmlToDraft(html_current);
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      const editorState = EditorState.createWithContent(contentState);

      this.setState({ editorState, openVideoRec: false, openRec: false });
    } catch (err) {
      swal("Problemas em anexar seu arquivo!", "Tivemos um problema ao anexar seu arquivo, por gentileza, tente novamente, se persistir, nos contate", "error");
    }
  }

  activeVideo() {
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
      navigator.mediaDevices.getUserMedia = function (constraintObj) {
        let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        if (!getUserMedia) {
          return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
        }
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraintObj, resolve, reject);
        });
      }
    } else {
      navigator.mediaDevices.enumerateDevices()
        .then(devices => {
          devices.forEach(device => {
            //, device.deviceId
          })
        })
    }

    navigator.mediaDevices.getUserMedia(constraintObj)
      .then((mediaStreamObj) => {
        //connect the media stream to the first video element
        let video = document.querySelector('#vid1');
        if ("srcObject" in video) {
          video.srcObject = mediaStreamObj;
        } else {
          //old version
          video.src = window.URL.createObjectURL(mediaStreamObj);
        }

        video.play();

        video.onloadedmetadata = function (ev) {
          //show in the video element what is being captured by the webcam
          video.play();
        };

        //add listeners for saving video/audio
        let start = document.getElementById('btnStart');
        let stop = document.getElementById('btnStop');
        let vidSave = document.getElementById('vid2');
        let downloadButton = document.getElementById("downloadButton");
        let mediaRecorder = new MediaRecorder(mediaStreamObj);
        let chunks = [];

        start.addEventListener('click', (ev) => {
          mediaRecorder.start();
          this.setState({ recordingVideo: true, anexarVideo: false })
        })
        stop.addEventListener('click', (ev) => {
          mediaRecorder.stop();
          this.setState({ recordingVideo: false, anexarVideo: true })
        });
        mediaRecorder.ondataavailable = function (ev) {
          chunks.push(ev.data);
        }
        mediaRecorder.onstop = (ev) => {
          blob = [];
          blob = new Blob(chunks, { 'type': 'video/mp4;' });
          chunks = [];
          let videoURL = window.URL.createObjectURL(blob);
          vidSave.src = videoURL;
        }
      })
    this.setState({ openVideoRec: true })
  }

  start = () => {
    if (!this.state.isBlocked) {
      Mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecording: true });
        }).catch((e) => console.error(e));
    }
  };

  stop = () => {
    Mp3Recorder
      .stop()
      .getMp3()
      .then(([buffer, blob]) => {
        let blobArchieve = blob;
        const blobURL = URL.createObjectURL(blob)
        this.setState({ blobURL, isRecording: false, blobArchieve });
      })
  };

  handlePastedFiles = (files) => {
    const ACCEPTED_MIMES_TYPES = [
      'image/png',
      'image/jpeg',
      'image/gif',
    ];

    if (files && files.length) {
      const file = files[0];

      if (ACCEPTED_MIMES_TYPES.includes(file.type)) {
        const data = new FormData();

        data.append("file", file);
        data.append("nome", `${Date.now()}`);
        data.append("path", 'imagens-voitto');

        api.post("/upload", data)
          .then(res => {
            const base = res.data.url.replace('%2F', '/');
            const newEditorState = this.insertImage(this.state.editorState, base);
            this.onChange(newEditorState);
          });
      }
    }
    return 'not-handled';
  };
  readImageAsDataUrl = (image, callback) => {

    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(image);
  };

  create = () => {
    this.props.sendResposta(stateToHTML(this.state.editorState.getCurrentContent()));
  }

  insertImage = (editorState, base64) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "image",
      "IMMUTABLE",
      { src: base64 }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity
    });
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
  };
  onChange = (editorState) => {
    this.setState({
      editorState,
    });
  };
  focus = () => {
    this.editor.focus();
  };
  render() {
    return (
      <>
        <div>
          <ContainerInput>
            <div style={{ display: 'flex', flexDirection: 'column', marginRight: '32px', paddingTop: '16px' }}>
              <Button color='grey' onClick={() => this.setState({ openRec: true })} style={{ marginBottom: '16px' }}>
                <Icon name='microphone' />
                            Enviar dúvida por áudio
                        </Button>
              <Button onClick={() => this.activeVideo()} color='grey'>
                <Icon name='video camera' />
                            Enviar dúvida por vídeo
                        </Button>

              <ButtonArquivo>
                <input
                  type='file'
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    opacity: 0,
                    cursor: 'pointer'
                  }}
                  onChange={(e) => this.uploadAnexo(e, 'arquivo')}
                />

                <Icon name='file' />
                            Anexar arquivo
                        </ButtonArquivo>
            </div>

            <div className='divEditor' style={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '9rem' }}>
              <div className='editor' onClick={this.focus}>
                <Editor
                  handlePastedFiles={this.handlePastedFiles}
                  editorState={this.state.editorState}
                  onChange={this.onChange}
                  plugins={plugins}
                  ref={(element) => {
                    this.editor = element;
                  }}
                />
                <Toolbar>
                  {
                    // may be use React.Fragment instead of div to improve perfomance after React 16
                    (externalProps) => (
                      <div>
                        <BoldButton {...externalProps} />
                        <ItalicButton {...externalProps} />
                        <UnderlineButton {...externalProps} />
                        <CodeButton {...externalProps} />
                        <Separator {...externalProps} />
                        <HeadlinesButton {...externalProps} />
                        <UnorderedListButton {...externalProps} />
                        <OrderedListButton {...externalProps} />
                        <BlockquoteButton {...externalProps} />
                        <CodeBlockButton {...externalProps} />
                      </div>
                    )
                  }
                </Toolbar>
              </div>

              <div>Não se equeça de zipar (.zip) se for enviar mais de um arquivos !</div>

              <Button onClick={this.create} color='green' style={{ alignSelf: 'flex-end' }}>
                Enviar
                        </Button>
            </div>
          </ContainerInput>

          <Modal
            onClose={() => {
            }}
            open={this.state.openVideoRec}
          >
            <Header icon='video' content={`Envie sua dúvida por vídeo`} />
            <Modal.Content>
              <center>
                <img width="200" src="https://www.voitto.com.br/assets/ckeditor2/plugins/mediarecorder/icons/logo.image" />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div>
                    <video id="vid1" style={{ width: 400, height: 320, display: this.state.anexarVideo == false ? 'block' : 'none' }} autoplay muted></video>
                    <video id="vid2" style={{ width: 400, height: 320, display: this.state.anexarVideo == true ? 'block' : 'none' }} controls></video>
                  </div>
                  <br />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button id="btnStart" style={{ display: this.state.recordingVideo == false ? 'block' : 'none' }} color='grey' icon labelPosition='left'>
                      <Icon name='video' />
                                        Gravar Vídeo
                                    </Button>
                    <Button id="btnStop" style={{ display: this.state.recordingVideo == true ? 'block' : 'none' }} color='red' icon labelPosition='left'>
                      <Icon name='circle' />
                                        Parar gravação
                                    </Button>
                    <Button disabled={this.state.anexarVideo == false} onClick={(e) => this.uploadAnexo(e, 'vídeo')} color='grey' icon labelPosition='left'>
                      <Icon name='check' />
                                        Anexar resposta
                                    </Button>
                  </div>
                </div>
              </center>
            </Modal.Content>

            <Modal.Actions>
              <Button
                onClick={() => {
                  this.setState({ openVideoRec: false })
                }}
                color='red'
                inverted>
                <Icon name='close' /> Fechar
                        </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            onClose={() => {
            }}
            open={this.state.openRec}
          >
            <Header icon='audio' content={`Envie sua dúvida por áudio`} />
            <Modal.Content>
              <center>
                <img width="200" src="https://www.voitto.com.br/assets/ckeditor2/plugins/mediarecorder/icons/logo.image" />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div>
                    {!this.state.isRecording
                      ? <Button onClick={this.start} color='grey' icon labelPosition='left'>
                        <Icon name='microphone' />
                                        Gravar Áudio
                                    </Button>
                      : <Button onClick={this.stop} color='red' icon labelPosition='left'>
                        <Icon name='circle' />
                                        Parar gravação
                                    </Button>
                    }
                    <Button disabled={this.state.blobURL == ''} onClick={(e) => this.uploadAnexo(e, 'áudio')} color='grey' icon labelPosition='left'>
                      <Icon name='check' />
                                        Anexar resposta
                                    </Button>
                  </div>
                  <br />
                  {this.state.isRecording
                    ? <p>Gravando...</p>
                    : <audio src={this.state.blobURL} controls="controls" />
                  }
                </div>
              </center>
            </Modal.Content>
            <Modal.Actions>
              <Button
                onClick={() => {
                  this.setState({ openRec: false })
                }}
                color='red'
                inverted>
                <Icon name='close' /> Fechar
                        </Button>
            </Modal.Actions>
          </Modal>
        </div>
      </>
    );
  }
}





